import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite
} from '../../../../../../../openapi';
import { CustomValidator, fromToDate } from '../../../../../../../common/forms/custom.validators';
import { toNumber } from '../../../../../../../services/helpers';

export type ProjectTypeItem = 'Stałej' | 'Tymczasowej' | string;

@Injectable()
export class TrafficOrganizationProjectForm extends AppForm {

  public projectTypes: ProjectTypeItem[] = [
    'Tymczasowej',
    'Stałej'
  ];

  constructor() {
    super({
      projectType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      trafficOrganizationDescription: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      startDate: new FormControl(
        null,
        [Validators.required, CustomValidator.minDate(new Date())]
      ),
      investor: new FormControl(null, Validators.maxLength(255))
    }, {
      validators: [fromToDate('startDate', 'endDate')]
    });
  }

  public projectTypeChange(v: ProjectTypeItem): void {
    if (v === 'Tymczasowej') {
      this.addControl('endDate', new FormControl(null, Validators.required));
      this.addControl('chainageFrom', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
      this.addControl('chainageTo', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('endDate');
      this.removeControl('chainageFrom');
      this.removeControl('chainageTo');
    }
    if (v === 'Stałej') {
      this.addControl('chainage', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('chainage');
    }
  }

  public get chainageFrom(): FormControl | null {
    return this.get('chainageFrom') as FormControl | null;
  }

  public get chainageTo(): FormControl | null {
    return this.get('chainageTo') as FormControl | null;
  }

  public get chainage(): FormControl | null {
    return this.get('chainage') as FormControl | null;
  }

  public get endDate(): FormControl | null {
    return this.get('endDate') as FormControl | null;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    let value = this.value;
    delete value.parcels;
    return {
      ...value,
      chainageFrom: toNumber(this.chainageFrom?.value),
      chainageTo: toNumber(this.chainageTo?.value),
      chainage: toNumber(this.chainage?.value)
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues(value);
    this.projectTypeChange(value?.projectType || '');

    this.chainageFrom?.setValue(value?.chainageFrom?.toString());
    this.chainageTo?.setValue(value?.chainageTo?.toString());
    this.chainage?.setValue(value?.chainage);

    this.endDate?.setValue(value?.endDate);
  }
}
